export const handleMensurationInput = (prev, values, currentStep, callback, setNewValues) => {

	switch(currentStep){
		case "1"		: return validateStep1(prev, values, setNewValues, callback);
		case "2"		: return validateStep2(prev, values, callback);
		case "3"		: return validateStep3(prev, values, callback);
		case "4"		: return validateStep4(prev, values, callback);
		case "5"		: return validateStep5(prev, values, callback);
		default 		: return "1" ;
	}

};

function validateStep1(prev, values, setNewValues, callback) {
	if(prev) return "return";

	const array = [];

	if(!values["1"])
		return "end";
	
	if(values["1"]["1"]) array.push({ "1": values["1"]["1"] });
	if(values["1"]["2"]) array.push({ "1": values["1"]["2"] });
	if(values["1"]["3"]) array.push({ "1": values["1"]["3"] });
	setNewValues(array);
	callback(mapToApi({values: array}), "mensuration");
	return "2";
};

function validateStep2(prev, values, callback) {
	if(prev) return "1";

	callback(mapToApi(values), "mensuration");
	return "3";
};

function validateStep3(prev, values, callback) {
	if(prev) return "2";

	callback(mapToApi(values), "mensuration");
	return "4";
};

function validateStep4(prev, values, callback) {
	if(prev) return "3";

	callback(mapToApi(values), "mensuration");
	return "end";
};


function mapToApi(values) {

	const toReturn = values.values.map( value => {
		return { 
			"1": value["1"] || "", 
			"2": value["2"] || "",
			"3": value["3"] || "",
			"4": value["4"] || "",
		};
	});

	return {
		input: toReturn
	};
};


// WEBPACK FOOTER //
// src/helpers/subcategoriesFunctions/handleMensurationInput.js